import { buildProps as r } from "./index601.js";
const o = r({
  vertical: Boolean,
  size: String,
  move: Number,
  ratio: {
    type: Number,
    required: !0
  },
  always: Boolean
});
export {
  o as thumbProps
};
